<div [formGroup]="group" [hidden]="config.hidden" class="form-group">
  @if (config.label) {
    <label [for]="config.fullyQualifiedName">{{ config.label | translate }}</label>
  }
  <select
    class="form-select"
    [class.missing]="isMissing"
    [class.complete]="isComplete"
    [class.invalid]="isInvalid"
    [formControlName]="config.formControlName"
    [id]="config.fullyQualifiedName"
    [name]="config.fullyQualifiedName"
    >
    <option [ngValue]="undefined" disabled selected hidden>
      {{ config.placeholder | translate }}
    </option>
    @for (option of config.options; track option) {
      <option [ngValue]="option.value || option">
        {{ (option.name | translate) || option }}
      </option>
    }
  </select>
</div>
